import { createAction, props } from "@ngrx/store";
import { User } from "../../shared/models/user.model";


export const login = createAction(
  '[Auth] Login',
  props<{ username: string, password: string }>()
);

export const loginSuccess = createAction(
  '[Auth] Login Success',
  props<{ token: string }>()
);

export const loadUserSuccess = createAction(
  '[Auth] Load User Success',
  props<{ user: any }>()
)

export const loginError = createAction(
  '[Auth] Login Error',
  props<{ error: any }>()
)

export const logout = createAction('[Auth] Logout')
export const logoutSuccess = createAction('[Auth] Logout Success')

export const updateUserStore = createAction(
  '[Auth] Update User Store',
  props<{ user: any }>()
);

export const setUser = createAction(
  '[Auth] Set User',
  props<{ user: User }>()
);

export const loadUserProfile = createAction(
  '[Auth] Load User Profile'
);
